import React from 'react';
import FileDocumentIcon from './FileDocumentIcon';
import FileIcon from './FileIcon';
import FileImageIcon from './FileImageIcon';
import FilePdfIcon from './FilePdfIcon';
import FileSpreadsheetIcon from './FileSpreadsheetIcon';
import FileWordIcon from './FileWordIcon';
import FileZipIcon from './FileZipIcon';
const getFileExtension = path => {
  return path.toLowerCase().split('.').pop();
};
const FileExtIcon = _ref => {
  let {
    filePath = '',
    ...props
  } = _ref;
  const ext = getFileExtension(filePath);
  switch (ext) {
    case 'pdf':
      return /*#__PURE__*/React.createElement(FilePdfIcon, props);
    case 'zip':
      return /*#__PURE__*/React.createElement(FileZipIcon, props);
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'svg':
      return /*#__PURE__*/React.createElement(FileImageIcon, props);
    case 'doc':
    case 'docx':
      return /*#__PURE__*/React.createElement(FileWordIcon, props);
    case 'lwp':
    case 'md':
    case 'odt':
    case 'pages':
    case 'rtf':
    case 'txt':
      return /*#__PURE__*/React.createElement(FileDocumentIcon, props);
    case 'csv':
    case 'xls':
    case 'xlsx':
    case 'numbers':
    case 'ods':
      return /*#__PURE__*/React.createElement(FileSpreadsheetIcon, props);
    default:
      return /*#__PURE__*/React.createElement(FileIcon, props);
  }
};
export default FileExtIcon;